jQuery(document).ready( function(){
	
  jQuery("#contact_form").validate({
        rules:{
          'contact[name]': "required",
          'contact[email]':{
            required: true,
            email: true
          },
          'contact[phone-number]':{
            required: true,
            number: true,
            maxlength: 15
          },
          'contact[body]':"required"  
        },
        messages:{
          'contact[name]':"Please enter your Name",
          'contact[email]':"Please enter valid email address",
          'contact[phone-number]':"Please enter valid Phone Number",
          'contact[body]':"Please enter your Message"      
        },
        submitHandler: function(form) {
          form.submit();
        }
  });
  
});